import { combineReducers } from 'redux'
import { reducers as coreReducers } from 'modules/core'

const rootReducer = combineReducers({
  ...coreReducers,
})

export default rootReducer
